import React from "react";
import {
  AuthLayout,
  EnterCodeForm,
} from "modules/Authentication/components";

type Props = {};

const EnterCodeContainer = (props: Props) => {


  return (
    <AuthLayout>
      <EnterCodeForm

      />
    </AuthLayout>
  );
};

export default EnterCodeContainer;
